import { mergeDeepRight } from 'utils/object'

const SLICE = 'timer'

// actions
export const START_TIMER = 'timer/START_TIMER'
export const startTimer = () => ({ type: START_TIMER })
export const FINISH_TIMER = 'timer/FINISH_TIMER'
export const finishTimer = message => ({
  type: FINISH_TIMER,
  payload: { message },
})
export const UPDATE_TIMER = 'timer/UPDATE_TIMER'
export const updateTimer = payload => ({ type: UPDATE_TIMER, payload })

// reducer
const initialState = { started: null, secondsTotal: 0, secondsLeft: 0 }
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_TIMER:
      return mergeDeepRight(state, action.payload)
    default:
      return state
  }
}

export const getTimer = state => state?.[SLICE]
